module.exports = __webpack_public_path__ + "img/home-w.318242d8.svg";